export const API_CONFIG = {
  BASE_URL: 'https://api.eservice-alhmod-alhajeri.com',
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/api/auth/login',
      LOGOUT: '/api/auth/logout',
      VERIFY: '/api/auth/verify',
      SETUP_ADMIN: '/api/auth/setup-admin'
    },
    MEMBERS: {
      LIST: '/api/members',
      ROOT: '/api/members/root',
      DETAIL: '/api/members/:id'
    },
    REQUESTS: {
      LIST: '/api/requests',
      CREATE: '/api/requests',
      APPROVE: '/api/requests/:id/approve',
      REJECT: '/api/requests/:id/reject'
    },
    UPLOAD: '/api/upload'
  },
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
} as const;